<template>
    <div class="warning">
        <div class="warning-container">
            <h2 class="title-warning">Atenção</h2>
            <p class="text-warning">
                Esse ranking <span class="bold">não tem influencia</span> na sua aprovação ou reprovação para 
                as próximas fases do processo.
            </p>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .warning{

        height: 10vh;
        width: 100%;
        background-color:#b3f8f5;
        text-align: center;
        display: flex;

        .warning-container{

            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: space-around;
            height: 80%;
            width: 100%;
            margin: auto 0;

            .title-warning{

                text-transform: uppercase;
                font-weight: bold;
                font-size: 14px;
                letter-spacing: 1px;
                color: #860080;
            }

            .text-warning{

                width: 80%;
                margin: 0 auto;
                font-size: 12px;
                color: #6e8082;

                .bold{

                    font-weight: bold;
                    color: black;
                }
            }
        }
    }

    @media only screen and (max-width: 350px){
        .warning{


            .warning-container{

                .title-warning{

                    font-size: 12px;
                }

                .text-warning{

                    font-size: 10px;

                    .bold{

                    }
                }
            }
        }
    }

    @media only screen and (min-width: 600px){
        .warning{

            .warning-container{

                .title-warning{

                    font-size: 16px
                }

                .text-warning{

                    font-size: 14px;
                    width: 50%;

                    // .bold{


                    // }
                }
            }
        }
    }
</style>

